<div class="make-it-yours">
	<h2>{{ 'COMMON.CEREMONY_MAKE_IT_YOURS' | translate }}</h2>
	<form [formGroup]="form">
		<table class="govuk-table govuk-table--small-text-until-tablet" *ngIf="dataStore.serviceFees">
			<thead class="govuk-table__head">
				<tr class="govuk-table__row">
					<th scope="col" class="govuk-table__header">Items</th>
					<th scope="col" class="govuk-table__header">Quantity</th>
					<th scope="col" class="govuk-table__header">Amount to pay</th>
					<ng-container *ngIf="daysAway > 182">
						<th scope="col" class="govuk-table__header">Deposit</th>
					</ng-container>
				</tr>
			</thead>
			<tbody class="govuk-table__body">
				<!-- <tr class="govuk-table__row">
								<th scope="row" class="govuk-table__header">{{service.name}}</th>
								<td class="govuk-table__cell">1</td>
								<td class="govuk-table__cell">{{dataStore.serviceFees.full_fee | currency:'GBP':'symbol':'1.2-2'}}</td>
								<td class="govuk-table__cell">{{dataStore.serviceFees.deposit | currency:'GBP':'symbol':'1.2-2'}}</td>
						</tr> -->
				<tr class="govuk-table__row" *ngFor="let fee of dataStore.serviceFees">
					<th scope="row" class="govuk-table__header">{{ fee.item }}</th>
					<td class="govuk-table__cell">{{ fee.quantity }}</td>
					<td class="govuk-table__cell">
						{{
						fee.cost * fee.quantity | currency : 'GBP' : 'symbol' : '1.2-2'
						}}
					</td>
					<ng-container *ngIf="daysAway > 182">
						<td class="govuk-table__cell">
							{{
							fee.deposit * fee.quantity
							| currency : 'GBP' : 'symbol' : '1.2-2'
							}}
						</td>
					</ng-container>
				</tr>
				<tr class="govuk-table__row">
					<td class="govuk-table__header total">Amount to pay</td>
					<td class="govuk-table__header">&nbsp;</td>
					<td class="govuk-table__header">
						{{ costTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
					</td>
					<ng-container *ngIf="daysAway > 182">
						<td class="govuk-table__header total">
							{{ depositTotal | currency : 'GBP' : 'symbol' : '1.2-2' }}
						</td>
					</ng-container>
				</tr>
			</tbody>
		</table>
		<p class="govuk-body" *ngIf="!dataStore.serviceFees">Calculating fees</p>

		@for(question of questions; track question.id) { @if(question.visible) {
		<label tabindex="0" for="{{ question.id }}">
			<span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">*</span>
			{{ question.name | translateSplit }}
		</label>
		@if(question.detailType === 'number') {
		<select formControlName="{{ question.id }}" class="govuk-select" [id]="question.id" [name]="question.id"
			[items]="question.options" (change)="onQuestionChange(question)">
			@for(option of question.options; track $index) {
			<option value="{{ option.name }}" [attr.selected]="option === question.defaultValue">
				{{ option.name }}
			</option>
			}
		</select>
		}
		<!-- if statement will change to check for 'number' once config is updated -->
		@if(question.detailType === 'select' || question.detailType === 'number') {
		<div class="number-input-container">
			<button class="btn btn-minus" [disabled]="question.answer === question.minimumValue"
				(click)="updateNumberInput(question.id, false, question.minimumValue, question.maximumValue)"
				aria-label="Decrease number of certificates by 1 (minus)">
				<i class="ph ph-minus" aria-hidden="true"></i>
			</button>
			<input type="number" [min]="question.minimumValue" [max]="question.maximumValue" class="number-input"
				formControlName="{{ question.id }}" [id]="question.id" [name]="question.id"
				[value]="question.defaultValue" aria-live="polite" />
			<button class="btn btn-plus"
				(click)="updateNumberInput(question.id, true, question.minimumValue, question.maximumValue)"
				aria-label="Increase number of certificates by 1 (plus)"
				[disabled]="question.answer === question.maximumValue">
				<i class="ph ph-plus" aria-hidden="true"></i>
			</button>
		</div>
		} } }

		<div class="govuk-form-group mb-0">
			<fieldset class="govuk-fieldset">
				<legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
					<h2 class="body-bold">
						{{ 'COMMON.PAYABLE_TODAY' | translate }}
					</h2>
				</legend>
        @if(isCeremonyInFuture && depositAvailable) {
          <ng-container>
            <div class="govuk-radios govuk-!-margin-bottom-4" data-module="govuk-radios">
              <div class="govuk-radios__item">
                <input formControlName="payment_type" class="govuk-radios__input" id="payment_type_full" name="payment_type" type="radio" value="full_balance"/>
                <label class=" govuk-radios__label" for="payment_type_full">
                  Full balance
                </label>
              </div>
              <div class="govuk-radios__item">
                <input formControlName="payment_type" class="govuk-radios__input" id="payment_type_deposit" name="payment_type" type="radio" value="deposit"/>
                <label class=" govuk-radios__label" for="payment_type_deposit">
                  Booking Fee
                </label>
              </div>
            </div>
          </ng-container>
        }
				<p>
					Please ensure that all information has been reviewed thoroughly. A £55 amendment fee will be applied should you request any changes to this reservation after the booking has been confirmed.</p> 
				<p>
					You need to pay <b>{{ totalCost | currency : 'GBP' : true }}</b> today to confirm your booking. You can pay by credit or debit card.</p> 
        <p>
          We cannot hold bookings without payment. If payment is not completed, your booking will be cancelled.</p>
         <p class="mb-0">
           If you are booking a ceremony date within the next 2 months, full payment must be made when booking.</p>
				<p class="mb-0">
          We’ll take payment on the next page.
				</p>
			</fieldset>
		</div>
	</form>
</div>
